import { isNinjaOne } from "../utils/mspUtils";
import { slugify } from "../utils/stringUtils";

export interface WorkScopeItem {
  text: string;
  path: string;
}

export const OPEN_TICKETS_PATH = "/supervisor";
export const OPEN_TICKETS_LABEL = "Open Tickets";

/** Table heading: the selected queue, board, team, or category, plus any status or customer filter. */
export function serviceDeskHeading(
  scopeLabel: string | undefined,
  status?: string[],
  customerNames?: string[]
): string {
  const parts = [String(scopeLabel || "").trim() || OPEN_TICKETS_LABEL];
  const statuses = (status || []).map((value) => String(value || "").trim()).filter(Boolean);
  if (statuses.length > 0) {
    parts.push(statuses.join(", "));
  }
  const customers = (customerNames || []).map((value) => String(value || "").trim()).filter(Boolean);
  if (customers.length > 0) {
    parts.push(customers.join(", "));
  }
  return parts.join(" · ");
}

/** NinjaOne's aggregate board. The Open Tickets row already covers it. */
export function isAggregateTicketBoard(name: string): boolean {
  return name.trim().toLowerCase() === "all tickets";
}

export function buildQueueScopeItems(
  mspType: string | undefined,
  technicianGroups: Array<{ name?: string }>,
  ninjaBoards: Array<{ name?: string }>
): WorkScopeItem[] {
  const source = mspType && isNinjaOne(mspType) ? ninjaBoards : technicianGroups;
  return source
    .map((item) => String(item?.name || "").trim())
    .filter((name) => Boolean(name) && !isAggregateTicketBoard(name))
    .map((name) => ({
      text: name,
      path: `/supervisor/${slugify(name)}`,
    }));
}

export function buildCategoryScopeItems(
  categories: Array<{ name?: string }>
): WorkScopeItem[] {
  return categories
    .map((category) => String(category?.name || "").trim())
    .filter(Boolean)
    .map((name) => ({
      text: name,
      path: `/supervisor/categories/${slugify(name)}`,
    }));
}
